import * as React from 'react';
export var IconArrowRight = React.forwardRef(function IconArrowRight({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'M12.76 8.55a.75.75 0 0 0 0-1.1L9.26 4.2a.75.75 0 1 0-1.02 1.1l2.1 1.95H3.75a.75.75 0 0 0 0 1.5h6.59l-2.1 1.95a.75.75 0 0 0 1.02 1.1l3.5-3.25Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'M18.768 12.543a.75.75 0 0 0 0-1.086l-5.502-5.25a.75.75 0 0 0-1.035 1.086l4.147 3.957H5.75a.75.75 0 0 0 0 1.5h10.628l-4.147 3.957a.75.75 0 1 0 1.036 1.086l5.5-5.25Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'M18.768 12.543a.75.75 0 0 0 0-1.086l-5.502-5.25a.75.75 0 0 0-1.035 1.086l4.147 3.957H5.75a.75.75 0 0 0 0 1.5h10.628l-4.147 3.957a.75.75 0 1 0 1.036 1.086l5.5-5.25Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
